import actionTypes from "../action-types";
import { CourseType } from "../models/state/courses/course/Course";

export function receiveCoursesDetails(coursesDetails: {
  courses: Array<CourseType>;
}) {
  return {
    type: actionTypes.RECEIVE_COURSES_DETAILS,
    payload: {
      coursesDetails: coursesDetails.courses
    }
  };
}

export function addCourse(course: Record<string, any>) {
  return {
    type: actionTypes.ADD_COURSE,
    payload: {
      course
    }
  };
}

export function addCourseSkeleton({ course, sections }: Record<string, any>) {
  return {
    type: actionTypes.ADD_COURSE_SKELETON,
    payload: {
      course,
      sections
    }
  };
}

export function addSection(section: Record<string, any>) {
  return {
    type: actionTypes.ADD_SECTION,
    payload: {
      section
    }
  };
}

export function addWord(word: Record<string, any>) {
  return {
    type: actionTypes.ADD_WORD,
    payload: {
      word
    }
  };
}
